import {useCallback, useEffect, useState} from "react"

import {useHistory,useParams}from "react-router-dom"
import InstituteService from "../../../services/InstituteService"
import CampusService from "../../../services/CampusService"
import AcademicUnitService from "../../../services/AcademicUnitService"
import UserService from "../../../services/UserService"
import {Form, Input, Button, message, Select,Steps,Card } from "antd"



const {Option}= Select;
const layout={
  labelCol:{
    span:10,
  },
  wrapperCol:{
    span:20,
  },
  style:{
    maxWidth:1000,
  },
  initialValues:{
    remember: true,
  }
}
export default function InstituteForm(){
  const history= useHistory();
  const params= useParams();
  const [form] = Form.useForm();
  const [listCampus,setListCampus]=useState([{}]);
  const [listAcademicUnit,setListAcademicUnit]=useState([{}]);
  const [listCoordinators,setListCoordinators]=useState([{}]);
  const [fields, setfields] = useState([]);
  const [fieldsSaves, setfieldsSaves] = useState({});
  const instituteId= params.id;
  const [valueAU, setValueAU] = useState(null);
  const [current,setCurrent]=useState(0)

  const createInstitute=useCallback((institute)=>{
    let instituteForm=institute;
    instituteForm=verificationFieldUndefined(institute)
      InstituteService.postInstitute(instituteForm)
      .then((res)=>{
        let {success,description}=res.data;
       if(success){
        message.success("Registro del instituto exitoso");
        history.goBack();
       }
       else{
        message.error(description);
       }
      })
  });
  const updateInstitute=useCallback((updateInstitute)=>{
    updateInstitute={
      id:instituteId,
      ...updateInstitute
    }
    updateInstitute=verificationFieldUndefined(updateInstitute)
    InstituteService.updateInstitute(updateInstitute)
    .then((res)=>{
      let {success,description}=res.data;
      if(success)
      {
      message.success("Actualizanción del instituto exitoso");
      history.goBack();
      }
      else{
        message.error(description)
      }
    })
  })
  const getInstituteById=useCallback((instituteId)=>{
      InstituteService.getInstituteById(instituteId)
        .then((res)=>{
          if(res.data?.response){
            const instituteRes=res.data.response
            if (res.data?.response){
              const fields=[
                {
                  name:["name"],
                  value: instituteRes.name || "",
                },
                {
                  name:["acronym"],
                  value: instituteRes.acronym || "",
                },
                {
                  name:["academicUnitId"],
                  value: instituteRes.academicUnitId || ""
                },
                {
                  name:["campusId"],
                  value: instituteRes.campusId || ""
                },
                {
                  name:["coordinatorId"],
                  value: instituteRes.coordinatorId || ""
                },
              ];
              
              setfields(fields);
              setValueAU(instituteRes.academicUnitId)
              AcademicUnitService.getListAcademitUnitByCampus(instituteRes.campusId).then((res)=>{
                setListAcademicUnit(res?.data?.response);
              })
            }
          }
        }).catch((e)=>{
          console.error(e)
        })
    },[]);


    const getAllCampus=useCallback(()=>{
      CampusService.getAllCampus().then((res)=>{
        setListCampus(res?.data?.response);
      })
    })
    const getAllAcademicUnit=useCallback((campusId,body)=>{
      setValueAU(null);
      AcademicUnitService.getListAcademitUnitByCampus(campusId).then((res)=>{
        setListAcademicUnit(res?.data?.response);
      })
      form.setFieldValue("academicUnitId",null)
    })

    const getAllcoordinator=useCallback((instituteId)=>{
      if(instituteId!== null && instituteId > 0){
        UserService.getUsersByUpdateCoordinatorOfInstitute(instituteId).then((res)=>{
          let {success,response,description}=res.data
          if(success){
            setListCoordinators(response)
          }else{
            message.error(description)
          }
        })
      }else{
        UserService.getUsersByCoordinatorOfInstitute().then((res)=>{
          let {success, response,description}=res.data
          if(success){
            setListCoordinators(response)
          }else{
            message.error(description)
          }
        })
      }
    },[])
    
    useEffect(()=>{

      getInstituteById(instituteId);
      getAllCampus();
      getAllcoordinator(instituteId);
    },[instituteId])

    const verificationFieldUndefined=(dataForm)=>{
      Object.keys(dataForm).map(e=>{
        dataForm[e]=dataForm[e]===undefined? null: dataForm[e];
      });
      return dataForm;
    }

    const onFinish= async()=>{
      try {
          let instituteData=fieldsSaves
          let dataForm=form.getFieldsValue()
          instituteData={
            ...instituteData,
            ...dataForm
          }
          if(instituteId!== null && instituteId > 0){
            updateInstitute(instituteData);
          }else{
            createInstitute(instituteData);
          }
        } catch (error) {
          console.log(error)
        }
      }

    const next = async()=> {
      try {
      await form.validateFields()
      let centerData=fieldsSaves
      let dataForm=form.getFieldsValue()
      setCurrent(current + 1);
      centerData={
        ...centerData,
        ...dataForm
      }
      setCurrent(current + 1);
      setfieldsSaves(centerData)

      } catch (error) {
        console.log(error)
      }
    };

    const prev = () => {
      setCurrent(current - 1);
    };
    const cancel=()=>{
      history.goBack();
    }
  
  const firstStep=()=>{
    return (
      <Form 
            {...layout}
            fields={fields}
            form={form}
            preserve={true}
            onFinish={next}
            >
              <Form.Item 
              name="name"
              label="Nombre del instituto"
              rules={[
                {
                  required: true,
                  message: 'Ingrese un nombre para instituto'
                }
              ]}
              >
                <Input/>
              </Form.Item>
              <Form.Item 
              name="acronym"
              label="Siglas del instituto"
              rules={[
                {
                  required: true,
                  message: 'Ingrese las siglas del instituto' 
                }
              ]}
              >
                <Input/>
              </Form.Item>
            </Form>
    )
  }

  const secondStep=()=>{
    return (
      <Form 
            {...layout}
            fields={fields}
            form={form}
            preserve={true}
            onFinish={next}
            scrollToFirstError
            >
              <Form.Item 
              name="campusId"
              label="Sede"
              rules={[
                {
                  required: true,
                  message: 'Seleccione lugar de la sede del instituto' 
                }
              ]}
              >
                <Select 
                placeholder="Selecciona una sede" 
                onChange={(value,body)=>{getAllAcademicUnit(value,body)}}
                >
                {
                  Object.keys(listCampus).map((i,key)=>{
                    return <Option value={listCampus[key].id  } key={listCampus[key].id}>{listCampus[key].name}</Option>
                  })
                }
                </Select>
              </Form.Item>
              <Form.Item 
              label="Unidad academica"
              name="academicUnitId"
              rules={[
                {
                  required: true,
                  message: 'Seleccione la unidad academica a la que pertenece' 
                }
              ]}
              >
                <Select
                placeholder="Selecciona una unidad academica " 
                value={valueAU}
                onChange={(val)=>{setValueAU(val)}}
                allowClear
                >
                  {
                  Object.keys(listAcademicUnit).map((i,key)=>{
                    return <Select.Option value={listAcademicUnit[key]?.id} key={listAcademicUnit[key].id}>{listAcademicUnit[key].name}</Select.Option>
                  })
                  }
                </Select>
              </Form.Item>
            </Form>
    )
  }

  const thirdStep=()=>{
    return (
      <Form 
            {...layout}
            fields={fields}
            form={form}
            preserve={true}
            scrollToFirstError
            onFinish={onFinish}
            >
              <Form.Item
            name="coordinatorId"
            label="Coordinador"
            >
              <Select 
              placeholder="Selecciona un coordinador"
              allowClear
              >
              {
                Object.keys(listCoordinators).map((i,key)=>{
                  return <Option value={listCoordinators[key].id  } key={listCoordinators[key].id}>{listCoordinators[key].firstName+" "+listCoordinators[key].lastName}</Option>
                })
              }
              </Select>
        </Form.Item>
      </Form>
    )
  }
  
  const items=[ {
    title: 'Datos generales',
    content: firstStep(),
  },
  {
    title: 'Ubicación',
    content: secondStep(),
  },
  {
    title: 'Coordinador',
    content: thirdStep(),
  },
];


    return (
    <>
    <Card style={{margin:50}}>
      <Steps
      items={items}
      current={current}
      style={{padding:20}}
      >
      </Steps>

      <Card>
        {items[current].content}
      </Card>
      {current < items.length -1 && (
          <Button type="submit" onClick={() => form.submit()}>
            Siguiente
          </Button>
        )}
        {current === items.length-1 && (
          <Button type="primary" onClick={() => form.submit()}>
            Finalizar
          </Button>
        )}
        {current > 0 && (
          <Button
            style={{
              margin: '0 8px',
            }}
            onClick={() => prev()}
          >
            Anterior
          </Button>
        )}
         {current === 0 && (
          <Button
            style={{
              margin: '0 8px',
            }}
            onClick={() => cancel()}
          >
            Cancelar
          </Button>
        )}
    </Card>
    </>
    )
}
